import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";

function AdminUserLogs({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = {
          page: page,
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getUserLogsAdmin(payload);
        // console.log(res);
        if (res?.success) {
          setData(res?.logs);
          setnoOfUser(res.count);
          setLimit(res.limit);
          setLoader(false);
        } else {
          alert("Email does not exist");
          setLoader(false);
        }
      } else {
        alert("Please insert email for search");
      }
    } catch (error) {
      alert("Invalid Email Address");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (searchMail) {
      handleSearch();
    }
  }, [page]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="payHistoryPage">
          <div className="row">
            {/* Area Chart */}
            <div className="col">
              <div className="row mx-0 drivers-row">
                <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                  <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                    Search User Logs
                    {/* ({noOfUser}) */}
                  </h4>
                  {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
                  <div className="searchMadmin">
                    <div className="inputM">
                      <div className="iM">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          onChange={(e) => setSearchMail(e.target.value)}
                          type="text"
                          placeholder="Search by email..."
                        />
                      </div>
                      <i
                        className="fa-solid fa-magnifying-glass sIcon"
                        onClick={handleSearch}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              {/* table */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                adminType={adminType}
              />
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noOfUser, limit, adminType }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col">Logged In IP</th>
                  <th scope="col">Device Name</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End TIme</th>
                  <th scope="col">Status</th>
                  {/* <th scope="col" className="">
                    Subscription End
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td scope="row">{item.ipAddress}</td>
                    <td>{item.device}</td>
                    <td>
                      <div className="dateTool">
                        <div className="fullDate">
                          {formatDate(item?.createdAt)}
                        </div>
                      </div>
                    </td>
                    <td>
                      {" "}
                      {item.status ? (
                        "On-going Session"
                      ) : (
                        <div className="dateTool">
                          <div className="fullDate">
                            {formatDate(item?.updatedAt)}
                          </div>
                        </div>
                      )}
                    </td>
                    <td>
                      {item.status ? (
                        <div className="badge bg-success">Active</div>
                      ) : (
                        <div className="badge bg-danger">Ended</div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminUserLogs;
